import * as Long from "long";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectBalancingSkipConstructionFactor } from "../../../../balancingSelectors/selectBalancingConstants";
import { IdResource } from "../../../../constants/IdResource";
import { selectBuildingConstructionInProgress } from "../../../../selectors/selectBuildingConstructionInProgress";
import { selectInventoryResourceInfo } from "../../../../selectors/selectInventoryInfo";
import { utilSkipProcess } from "../../../../utils/utilSkipProcess";
import { utilTime } from "../../../../utils/utilTime";
import { actionBeginBuyWithGoldProcess } from "../../../buy-with-gold/actionBuyWithGold";
import { actionOngoingPurchasePremiumDeselect } from "../../../ongoing-purchase/actionOngoingPurchase";
import { actionBuildingsSkipConstructionConfirmed, TypeActionBuildings, } from "../actionBuildings";
import { TypeBuildingAction } from "../reducerBuildings";
export var epicBuildingsSkipConstruction = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.SkipConstruction), switchMap(function (action) {
        var state = state$.value;
        var building = action.building;
        var buildingToSkipConstruction = building;
        if (action.action === TypeBuildingAction.Construct) {
            buildingToSkipConstruction = selectBuildingConstructionInProgress(state);
        }
        var remainingTime = utilTime.secondsLeftTill(buildingToSkipConstruction.proto.remainingTime);
        var factor = selectBalancingSkipConstructionFactor();
        // TODO: {long} check if cast is valid
        var GoldCost = Long.fromInt(utilSkipProcess.calculateCostToSkipProcess(remainingTime, factor));
        var playerGold = selectInventoryResourceInfo(state, IdResource.Gold);
        return of(actionBeginBuyWithGoldProcess(playerGold.amount || Long.ZERO, GoldCost, actionBuildingsSkipConstructionConfirmed(action.building, action.action), actionOngoingPurchasePremiumDeselect()));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsSkipConstruction.ts
// module id = 2084
// module chunks = 3